import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {CommonModule} from '@angular/common';
@Component({
    selector: 'app-key-metric',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './key-metric.component.html',
    styleUrl: './key-metric.component.scss'
})
export class KeyMetricComponent {
    @Input() infoName!: string;
    @Input() infoValue!: Number;
    @Input() infoIconSrc!: string;
    @Input() infoIconAlt!: string;
    @Input() infoLink?: string;

    constructor(private router: Router) {}

    onTileClick(): void {
        if (this.isClickable) {
            console.log(this.infoLink);
            this.router.navigate([this.infoLink]);
        }
    }

    get isClickable(): boolean {
        return !!this.infoLink?.length;
    }
}
